var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-box"},[_c('div',{staticClass:"list-top"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"list-top-more",on:{"click":_vm.toMoreList}},[_vm._v(" 更多"),_c('van-icon',{staticClass:"list-top-more-icon",attrs:{"name":"arrow"}})],1)]),_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }